/** 工程现场图片：中文标注对应图内文字；英文标注对应附件文件名中的英文部分 */
export const PROJECT_SITE_IMAGES = [
  {
    src: '/images/project-site-1.png',
    altZh: '机场',
    labelEn: 'Airport'
  },
  {
    src: '/images/project-site-2.png',
    altZh: '关键基础设施',
    labelEn: 'Infrastructure'
  },
  {
    src: '/images/project-site-3.png',
    altZh: '炼油厂',
    labelEn: 'Refinery'
  },
  {
    src: '/images/project-site-4.png',
    altZh: '大型活动',
    labelEn: 'Public Event'
  }
];
